/**
 * Directive: fieldFocus
 */
angular.module('acme.common.directive.fieldFocus', [])
.directive('fieldFocus', [ '$timeout', function($timeout) {

    return {
      restrict: 'A',

      link: function($scope, element, attrs) {

        $scope.$watch(attrs.fieldFocus, function(value) {
          var t = parseInt(attrs.fieldFocusTimeout, 10),
              timer = (!isNaN(t) && t >= 0) ? attrs.fieldFocusTimeout : 400;

          if(value === true || value === 'true') {
            if (attrs.fieldFocusTimeout && !isNaN(parseInt(attrs.fieldFocusTimeout, 10))) {
              timer = attrs.fieldFocusTimeout;
            }
            $timeout(function() {
              element[0].focus();
              if (attrs.fieldFocusAutoSelect === true || attrs.fieldFocusAutoSelect === 'true') {
                element[0].setSelectionRange(0, element[0].value.length);
              }
            }, timer, false);
          }
        });
        // to address @blesh's comment, set attribute value to 'false'
        // on blur event:
        //$element.bind('blur', function() {
        //  if (typeof(model.assign) === 'function') {
        //    $scope.$apply(model.assign($scope, false));
        //  }
        //});
      }

    };

}]);